import React, { useState } from 'react';
import {Modal,Box,Typography,TextField,Button,Divider,Select,MenuItem,FormControl,InputLabel,Alert,} from '@mui/material';
import { Lend } from '../../../../models/lend'; // Asegúrate de importar el tipo Lend
import { nowOperationalDateString } from '../../../../utils/operationalDateTime';

interface UpdateDateModalProps {
  open: boolean;
  onClose: () => void;
  client: Lend | null;
  clientId?: number;
  showAlert: (message: string, severity?: 'success' | 'info' | 'warning' | 'error') => void;
  showLoading: () => void;
  hideLoading: () => void;  
}

// Estilos del modal
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: '90vw', // Usa el 90% del ancho de la pantalla
  maxWidth: 500, // Pero no excedas los 500px en pantallas grandes
  height: '80vh', // Usa el 80% del alto de la pantalla
  maxHeight: 500, // Altura máxima para escritorio
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 2,
  //  p: { xs: 2, sm: 4 },   
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  overflowY: 'auto', // Permite desplazamiento si el contenido se desborda
};


const UpdateDateModal: React.FC<UpdateDateModalProps> = ({ open, onClose, client, clientId }) => {
  const [newDate, setNewDate] = useState(''); // Estado para la fecha nueva
  const [errorMessage, setErrorMessage] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const handleAccept = async () => {
    setIsSaving(true);

    if (!newDate) {
      setErrorMessage('Debe seleccionar una nueva fecha.');
      setIsSaving(false);
      return;
    }

    const formData = {
      lend_id: Number(clientId),
      new_date: newDate, // Enviar la nueva fecha al servidor
    };

    try {
      // Aquí iría la lógica para enviar los datos al servidor
      setErrorMessage('');
      onClose(); // Cerrar el modal después de guardar
    } catch (error) {
      setErrorMessage('Error actualizando la fecha. Intente más tarde.');
    } finally {
      setIsSaving(false);
    }
  };

  const handleClose = () => {
    setNewDate('');
    setErrorMessage('');
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box>
          <Typography variant="h4" component="h2" gutterBottom>
            Actualizar Fecha
          </Typography>
          <Typography variant="body1" gutterBottom>
            ¿Está seguro de querer modificar la fecha del préstamo #{clientId}?
          </Typography>
          {errorMessage && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {errorMessage}
            </Alert>
          )}
          <Divider sx={{ mb: 2 }} />
          <Typography variant="body1" gutterBottom>

          </Typography>
          <TextField
            fullWidth
            type="text"
            label="Fecha de Inicio Actual"
            value={client?.date}
            onChange={(e) => setNewDate(e.target.value)}
            InputLabelProps={{
              shrink: true, disabled: true
            }}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            type="date"
            label="Agregar una Fecha Nueva:"
            value={newDate}
            onChange={(e) => setNewDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{ max: nowOperationalDateString() }}
            sx={{ mb: 2 }}
          />
        </Box>
        {/* Contenedor de botones en la parte inferior */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
          <Button variant="outlined" onClick={handleClose}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={handleAccept}
            disabled={isSaving}
          >
            Guardar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default UpdateDateModal;